/**
 * Copyright (c) 2021
 *
 * Contains the representation of a ComponentKindEnumType
 *
 * @summary ComponentKindEnumType enum definition
 * @author Julien <julien.donnadieu@yooda.com>
 *
 * Created at     : 2021-08-17 10:21:56
 * Last modified  : 2021-08-17 16:40:37
 */

const ComponentKindEnumType = {
    COMPONENT_KIND_METERED: 'metered_component',
    COMPONENT_KIND_QUANTITY_BASED: 'quantity_based_component',
    COMPONENT_KIND_ON_OFF: 'on_off_component',
}

export default ComponentKindEnumType
